module.exports = __webpack_public_path__ + "static/media/lowcost.6e175622.webp";